import { render, staticRenderFns } from "./template-container.vue?vue&type=template&id=183bad19"
import script from "./template-container.vue?vue&type=script&lang=js"
export * from "./template-container.vue?vue&type=script&lang=js"
import style0 from "./template-container.vue?vue&type=style&index=0&id=183bad19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports